// Конфигурационный файл приложения

// Определение типа окружения
export type Environment = 'development' | 'production' | 'test';

// Интерфейс конфигурации приложения
export interface AppConfig {
  apiUrl: string;
  environment: Environment;
  enableLogging: boolean;
}

// Получение текущего окружения
const getEnvironment = (): Environment => {
  const env = process.env.NODE_ENV;
  if (env === 'development' || env === 'production' || env === 'test') {
    return env;
  }
  return 'development'; // значение по умолчанию
};

// Получение API URL из переменных окружения
const getApiUrl = (): string => {
  // Сначала пробуем window.env (для Docker)
  if (typeof window !== 'undefined' && (window as any).env?.REACT_APP_API_URL) {
    return (window as any).env.REACT_APP_API_URL;
  }
  // Затем process.env (для сборки)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Значение по умолчанию
  return 'http://0.0.0.0:8000';
};

// Базовая конфигурация
const baseConfig: AppConfig = {
  apiUrl: getApiUrl(),
  environment: getEnvironment(),
  enableLogging: getEnvironment() !== 'production',
};

// Конфигурация для разных окружений
const environmentConfigs: Record<Environment, Partial<AppConfig>> = {
  development: {
    apiUrl: 'http://0.0.0.0:8000',
    enableLogging: true,
  },
  production: {
    apiUrl: getApiUrl(),
    enableLogging: false,
  },
  test: {
    apiUrl: 'http://localhost:3001',
    enableLogging: false,
  },
};

// Финальная конфигурация
const config: AppConfig = {
  ...baseConfig,
  ...environmentConfigs[baseConfig.environment],
};

export default config;
